<script setup lang="ts" generic="T">
import { inject } from 'vue';
import { tabsRegistryKey } from './internal';
import type { TabEntry } from './useTabsRegistry';

// Renderless: the consumer owns the markup + a11y wrapper. The slot yields each
// tab's name, info (T), active state, and select().
defineSlots<{ default(props: { tabs: TabEntry<T>[] }): unknown }>();

const registry = inject(tabsRegistryKey);
if (!registry) throw new Error('[nx-ui] TabSelectors must be used inside TabsRoot');
</script>

<template>
  <slot :tabs="registry.entries.value as TabEntry<T>[]" />
</template>
